import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "purchase-orders"
    }}>{`Purchase Orders`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Many businesses need to generate a high volume of purchase orders (POs) in PDF format for services and source products. The data required for compliant POs is often tracked in several systems, and it becomes tedious for teams to manually include the correct details for different suppliers, products, regions, etc. Automating the generation of these documents saves time and boosts efficiency for these teams.`}</p>
    <p>{`Adobe Acrobat Services allows organizations to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard branded templates for purchase orders`}</li>
      <li parentName="ul">{`Merge purchase order data automatically into template documents`}</li>
      <li parentName="ul">{`Gather comments and feedback on documents`}</li>
      <li parentName="ul">{`Protect documents from editing with a password`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`The procurement team in a large manufacturing company is looking to efficiently generate customized purchase orders. Their procurement system has most of the information they need. In addition, they want to include specific terms and conditions, notes, and disclaimers in the document depending on the products, vendors, and regions used — all without creating a more time-consuming process.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the purchase order template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a final sales quote in PDF`}</li>
      <li parentName="ol">{`Use Adobe PDF Services API to protect the document from editing`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      